import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import TextField from './TextField';
import TimeField from 'react-simple-timefield';

export default class Time extends React.Component
{
    static propTypes = {
        id: PropTypes.string.isRequired,

        label: PropTypes.string,
        help: PropTypes.string,
        hint: PropTypes.string,

        value: PropTypes.string,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        label: '',
        help: '',
        hint: '',

        value: '00:00',
        onChange: () => {}
    };

    render()
    {
        return <TimeField
            value={this.props.value}
            input={<TextField {...this.props} />}
            onChange={(event, value) => this.props.onChange(value)}
        />;
    }
}
